import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
const state = {
  indicadores: [],
  indicadorCiudad: []
};

const getters = {
  [types.ALL_INDICADORES]: state => {
    return state.indicadores;
  },
  [types.INDICADOR_CIUDAD]: () => {
    return storeInstance.state.NGUD.CiudadSelected !== null ? storeInstance.state.NGUD.CiudadSelected.indicadores : [];
  }
};

const mutations = {
  [types.MUTATE_ALL_INDICADORES]: (state, payload) => {
    state.indicadores = payload;
  },
  [types.MUTATE_INDICADOR_CIUDAD]: (state, payload) => {
    state.indicadorCiudad = payload;
  }

};

const actions = {
  [types.ACTION_GET_ALL_INDICADORES]: ({ commit }) => {
    let request = { controller: '/Indicador' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_INDICADORES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR]: ({ commit }, payload) => {
    let request = { controller: '/Indicador/' + payload.idIndicador };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR_INDICE_TEMATICO]: ({ commit }, payload) => {
    let request = { controller: '/Indicador/IndiceTematico/' + payload.idIndiceTematico };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR_CIUDAD]: ({ commit }, payload) => {
    let request = null;
    if (payload.idRelacionAUE !== null && payload.idRelacionAUE !== undefined) {
      request = { controller: '/Indicador/' + payload.idIndicador + '/Ciudad/' + payload.idCiudad + '/?id=' + payload.idRelacionAUE };
    } else {
      request = { controller: '/Indicador/' + payload.idIndicador + '/Ciudad/' + payload.idCiudad };
    }
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR_INDICE_CIUDAD]: ({ commit }, payload) => {
    let request = null;
    let paramIndiceTematico = '';
    let paramObjetivoEstategico = '';
    let paramAdd = '';
    paramIndiceTematico = payload.idIndiceTematico !== undefined ? 'idIndiceTematico=' + payload.idIndiceTematico : '';
    paramObjetivoEstategico = payload.idObjetivoEstrategico !== undefined ? 'idObjetivoEstrategico=' + payload.idObjetivoEstrategico : '';
    paramAdd = payload.idIndiceTematico !== undefined && payload.idObjetivoEstrategico !== undefined ? '&' : '';
    request = { controller: '/Indicador/Ciudad/' + payload.idCiudad + '/IndiceTematico?' + paramIndiceTematico + paramAdd + paramObjetivoEstategico };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ALL_INDICADORES_OBSERVATORIO]: ({ commit }, payload) => {
    let request = null;
    let paramObjetivoEstategico = '';
    let paramSatelital = '';
    let paramAdd = '';
    paramObjetivoEstategico = payload.idObjetivoEstrategico !== undefined ? 'idObjetivoEstrategico=' + payload.idObjetivoEstrategico : '';
    paramAdd = payload.satelitales && payload.idObjetivoEstrategico !== undefined ? '&' : '';
    paramSatelital = payload.satelitales ? 'satelitales=' + payload.satelitales : '';
    request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/ObjetivoEstrategico?' + paramObjetivoEstategico + paramAdd + paramSatelital };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADORESAUE_CIUDAD]: ({ commit }, payload) => {
    let request = null;
    let paramObjetivoEstategico = '';
    paramObjetivoEstategico = payload.idObjetivoEstrategico !== undefined ? 'idObjetivoEstrategico=' + payload.idObjetivoEstrategico : '';
    request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/ObjetivoEstrategico?' + paramObjetivoEstategico };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR_SATELITAL]: ({ commit }, payload) => {
    let request;
    if (payload.id !== undefined) {
      request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/IndicadorSatelital/' + payload.idIndicador + '/Relacion/' + payload.id };
    } else {
      request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/IndicadorSatelital/' + payload.idIndicador + '/Relacion' };
    }

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADOR_ZONA]: ({ commit }, payload) => {
    let request = { controller: '/Indicador/' + payload.idIndicador + '/Ciudad/' + payload.idCiudad + '/Zona/' + payload.idZona };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/ObjetivoEspecifico/' + payload.idObjetivoEspecifico };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICADORSATELITAL_OBJETIVOESPECIFICO]: ({ commit }, payload) => {
    let request = { controller: '/Indicador/ObjetivoEspecifico/' + payload.idObjetivoEspecifico + '/Ciudad/' + payload.idCiudad };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_DATA_INDICADORAUE]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/Indicador/' + payload.idIndicadorAUE };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_GET_ACCIONES_ASOCIADAS]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/IndicadorAUE/' + payload.idIndicadorAUE + '/Acciones' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ACCIONES_ASOCIADAS_SATELITALES]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/Indicador/' + payload.idIndicador + '/Acciones' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_FASES_INDICADORAUE]: ({ commit }) => {
    let request = { controller: '/CiudadIndicadoresAUE/Fases' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_CARACTERES_INDICADORAUE]: ({ commit }) => {
    let request = { controller: '/CiudadIndicadoresAUE/Caracteres' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_PLAZOS_INDICADORAUE]: ({ commit }) => {
    let request = { controller: '/CiudadIndicadoresAUE/Plazos' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_PERIODICIDAD]: ({ commit }) => {
    let request = { controller: '/CiudadIndicadoresAUE/Periodicidades' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_INDICADORAUE]: ({ commit }, payload) => {
    let request = {
      controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad,
      filter: {},
      body: payload.dataIndicador
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postSuit', request)
        .then(response => {
          Message.showMessage('El indicador se ha actualizado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_SAVE_INDICADOR_DOCUMENTOPDF]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/DocumentoPDF',
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.file
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postFile', request)
        .then(response => {
          resolve(response.data.id);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_IS_ACCION_ASOCIADA]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/Accion/' + payload.idAccion };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_CSV_INDICADOR]: ({ commit }, payload) => {
    let request = null;
    let paramIndiceTematico = '';
    let paramObjetivoEstategico = '';
    let paramAdd = '';
    let paramAddSatelital = '';
    let paramSatelital = '';
    paramIndiceTematico = payload.idIndiceTematico !== undefined ? 'idIndiceTematico=' + payload.idIndiceTematico : '';
    paramObjetivoEstategico = payload.idObjetivoEstrategico !== undefined ? 'idObjetivoEstrategico=' + payload.idObjetivoEstrategico : '';
    paramAdd = payload.idIndiceTematico !== undefined & payload.idObjetivoEstrategico !== undefined ? '&' : '';
    paramSatelital = payload.satelitales ? 'satelitales=' + payload.satelitales : '';
    paramAddSatelital = payload.satelitales !== undefined & payload.idObjetivoEstrategico !== undefined ? '&' : '';
    request = { controller: '/CiudadZona/' + payload.idCiudad + '/CSV?' + paramIndiceTematico + paramAdd + paramObjetivoEstategico + paramAddSatelital + paramSatelital };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuitBlob', request)
        .then((response) => {
          var disposition = response.request.getResponseHeader('Content-Disposition');
          var filename = '';
          if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.click();
          resolve(url);
        })
        .catch(err => {
          Message.showError('No hay datos para exportar, consulte con el administrador.');
          reject(err);
        });
    });
  },

  [types.ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO_TARJETASINDICADORESACCIONES]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/ObjetivoEspecifico/' + payload.idObjetivoEspecifico + '/TarjetasDeIndicadoresConAcciones' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_DETALLE_INDICADOR_AUE]: ({ commit }, payload) => {
    let request = { controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/' + payload.idCiudadIndicadorAUE + '/DetalleIndicadorAUE' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_DATOS_INTERMEDIOS]: ({ commit }, payload) => {
    let request = {
      controller: '/CiudadIndicadoresAUE/Ciudad/' + payload.idCiudad + '/' + payload.idCiudadIndicadorAUE + '/DatosIntermedios',
      filter: {},
      body: payload.datosIntermedios
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/putSuit', request)
        .then(response => {
          Message.showMessage('El dato intermedio se ha actualizado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_GET_INDICADOR_TARJETA]: ({ commit }, payload) => {
    let request = { controller: '/Indicador/' + payload.idIndicador + '/Ciudad/' + payload.idCiudad + '/Tarjeta' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_INDICADOR]: ({ commit }, payload) => {
    let request = {
      controller: '/Indicador/' + payload.idIndicador,
      filter: {},
      body: payload.dataIndicador
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/putSuit', request)
        .then(response => {
          Message.showMessage('El indicador se ha actualizado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }

};

export default {
  actions,
  state,
  getters,
  mutations
};
